export default __webpack_public_path__ + "static/media/life_at_willow_walk.4f92d75d.mp4";